module.exports = __webpack_public_path__ + "img/infoImg1.768a4e33.png";